import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

function Architecture() {
  return (
    <>
      <Container
        fluid
        style={{
          minHeight: "80vh",
        }}
        className="App"
      >
        <Row>
          <Col className="App-architecture-page-bg"></Col>
        </Row>
        <Row className="App-section App-bg-color-beige">
          <Col className="App-section-col">
            <h1
              className="tinos-regular"
              style={{
                paddingBottom: "20px",
              }}
            >
              architecture
            </h1>
            <div className="quattrocento-sans-bold">
              At urban group, our architectural team will work closely with you
              to design and plan your project from start to finish, whether it
              is a multi-storey office block or an extension to your home.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We offer a Fixed Pricing Plan so that everyone knows how much the
              architectural aspect of the project is going to cost from the
              outset.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We work with local councils and the planning departments. We
              design and prepare drawings and work closely with our construction
              department should you also select our Construction Services.
            </div>
            <div className="quattrocento-sans-bold">
              With our flexible approach, Urban Group can also work with your
              chosen builder and carry out interim inspections or full
              supervision on your project.
            </div>
            <div className="quattrocento-sans-bold">
              After we produce detailed drawings and specifications, if you
              choose to go out to tender, we can draw up a list of contractors
              with you and invite them submit tender returns (including Urban
              Group's Construction Division), selecting the most suitable team
              for your project.
            </div>
            <br />
            <Button
              style={{
                marginBottom: "20px",
                fontFamily: "Quattrocento Sans, sans-serif",
                fontWeight: "700",
              }}
              href="mailto:HelloUrbanGroup@gmail.com"
              variant="light"
            >
              contact us
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Architecture;
